import { useToast } from "vue-toastification";
import { ref } from "vue";

export function useAttachments({ max_size = -1 } = {}) {
  const toast = useToast();

  const attachments = ref([]);

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files.length > 0) {
      const fileArray = Array.from(files);
      fileArray.forEach((file) => {
        if (max_size > 0 && file.size > max_size) {
          toast.error(
            `File "${file.name}" exceeds ${getHumanReadableSize(max_size)} limit and will not be added.`
          );
          return;
        }
        attachments.value.push(file);
      })
    }

    // assuming upload button, reset upload
    event.target.value = ''
  };

  const handleFileDelete = (index) => {
    attachments.value.splice(index, 1);
  };

  return {
    attachments,
    handleFileChange,
    handleFileDelete,
  };
}

function getHumanReadableSize(size) {
  let human = "";
  // Lets not talk about Megibytes...
  let kb = 1024;
  let mb = 1024 * kb;
  let gb = 1024 * mb;
  if (size > 0) human = `${size} B`;
  if (size > kb) human = `${Math.floor(size / kb)} KB`;
  if (size > mb) human = `${Math.floor(size / mb)} MB`;
  if (size > gb) human = `${Math.floor(size / gb)} GB`;
  return human;
}
